$(document).ready(function () {
    const $blackBox = $(".black-box");
    const $imageWrapper = $(".image-wrapper");

    setTimeout(() => {
        $blackBox.addClass("animate");
    }, 100);
    setTimeout(() => {
        $blackBox.addClass("hidden");
    }, 500);
    setTimeout(() => {
        $imageWrapper.addClass("animate visible");
    }, 2000);

    //recruit image animation
    const $items = $(".job_openings_item");

    // 要素が画面内に入ったかを判定
    function isElementInViewport($element) {
        const elementTop = $element.offset().top;
        const elementBottom = elementTop + $element.outerHeight();
        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    // アニメーションを実行
    function animateItem($item) {
        const $blackBox = $item.find(".recruit-black");
        const $image = $item.find("img");
        const $content = $item.find(".job_openings_item_content");

        // ① 黒いボックスを左から展開
        $blackBox.addClass("expand");

        // ② 黒いボックスを右へ消す
        setTimeout(() => {
            $blackBox.removeClass("expand").addClass("hidden");
        }, 1000); // 展開してから1秒後に消える

        // ③ 画像をフェードイン
        setTimeout(() => {
            $image.css({
                opacity: 1,
                transform: "scale(1)",
            });
        }, 1500); // 黒いボックスが消えた後に画像を表示

        // ④ コンテンツを左からフェードイン
        setTimeout(() => {
            $content.addClass("visible");
        }, 2000); // 画像のフェードイン後にコンテンツを表示
    }

    // スクロール時に要素をチェック
    function checkAndAnimateItems() {
        $items.each(function () {
            const $item = $(this);

            if (isElementInViewport($item) && !$item.hasClass("animated")) {
                $item.addClass("animated");
                animateItem($item);
            }
        });
    }

    // スクロールイベントを監視
    $(window).on("scroll", checkAndAnimateItems);

    // 初回ロード時に要素をチェック
    checkAndAnimateItems();

    // questions animation
    $('.question_item').click(function() {
        $(this).children('.answer').toggleClass('active');
        $(this).toggleClass('no-after');
    });
});